import { InputHelpMessageStateType } from '../../../../../components/internal/inputHelpMessage/types/inputHelpMessageStateType';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
const commonStateStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    ...STATE_TOKENS,
    typography: {
        font_weight: FONT_WEIGHT.font_regular,
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        color: FOUNDATIONS.color_comp_forms_input_secondaryfont,
        ...STATE_TOKENS.typography,
    },
});
export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    [InputHelpMessageStateType.FOCUSED]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputHelpMessageStateType.FOCUSED] }),
    },
    [InputHelpMessageStateType.EMPTY]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputHelpMessageStateType.EMPTY] }),
    },
    [InputHelpMessageStateType.FILLED]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputHelpMessageStateType.FILLED] }),
    },
    [InputHelpMessageStateType.ERROR_EMPTY]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputHelpMessageStateType.ERROR_EMPTY] }),
    },
    [InputHelpMessageStateType.ERROR_FILLED]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputHelpMessageStateType.ERROR_FILLED] }),
    },
    [InputHelpMessageStateType.DISABLED_EMPTY]: {
        ...commonStateStyles(FOUNDATIONS, {
            typography: {
                color: FOUNDATIONS.color_accent_disabled_font_100,
            },
            ...STATE_TOKENS[InputHelpMessageStateType.DISABLED_EMPTY],
        }),
    },
    [InputHelpMessageStateType.DISABLED_FILLED]: {
        ...commonStateStyles(FOUNDATIONS, {
            typography: {
                color: FOUNDATIONS.color_accent_disabled_font_50,
            },
            ...STATE_TOKENS[InputHelpMessageStateType.DISABLED_FILLED],
        }),
    },
});
//# sourceMappingURL=commonStyles.js.map